import { defineStore } from "pinia";

export const useMediaStore = defineStore("MediaStore", {
  state: () => ({
    medias: [],
    sliders: [],
    slidersKeberlangsungan: [],
    slidersCareer: [],
  }),
  getters: {},
  actions: {
    // API
    async getMedia(params) {
      try {
        const res = await $fetch("/api/media/get-media", {
          method: "POST",
          body: params,
        });
        this.medias = { ...this.medias, [params.menu]: res.data };
        return res;
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },

    async getSlider(params) {
      try {
        const res = await $fetch("/api/media/get-slider", {
          method: "POST",
          body: params,
        });

        switch (params.menu) {
          case 2:
            this.slidersKeberlangsungan = res.data;
            break;
          case 6:
            this.slidersCareer = res.data;
            break;
          default:
            this.sliders = res.data;
            break;
        }

        return res;
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },

    async getBanner(params) {
      try {
        const res = await $fetch("/api/media/get-banner", {
          method: "POST",
          body: params,
        });

        this.banners = res.data;
        return res;
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },

    // METHOD
    getContent(id, name) {
      return this.medias[id]?.find(
        (media) => media.media_desc.toLowerCase() == name.toLowerCase(),
      );
    },

    resetSlider(id) {
    },
  },
});
